// Root reducer del progetto. Fase 6 chiusa: lo stato è ora interamente
// gestito da slice RTK in `src/store/slices/`. Niente più `handlers` switch-
// style. Lo shape al top level è preservato (back-compat con i consumer
// `state.<key>`); ogni slice gestisce la propria chiave.

import { AUTH_LOGOUT } from '../actions/AuthActions';
import cdiFiltersReducer from '../slices/cdiFiltersSlice';
import groupedTripsFiltersReducer from '../slices/groupedTripsFiltersSlice';
import searchReducer from '../slices/searchSlice';
import languageReducer from '../slices/languageSlice';
import {
  calendarDateReducer,
  beginDateCalendarReducer,
  startTimelineReducer,
  endTimelineReducer,
} from '../slices/calendarSlices';
import { singletonReducers } from '../slices/singletonSlices';
import { crudListReducers } from '../slices/crudListSlices';
import { streamReducers } from '../slices/streamSlices';
import tripGroupsReducer from '../slices/tripGroupsSlice';
import driverWarningsReducer from '../slices/driverWarningsSlice';
import distanceCacheReducer from '../slices/distanceCacheSlice';

// Map { stateKey: reducer } — ogni reducer gestisce la propria chiave.
// L'ordine non importa: i reducer sono indipendenti e operano solo sulla
// loro sotto-chiave (immutability via Immer dentro lo slice).
const sliceReducers = {
  cdi_filters: cdiFiltersReducer,
  grouped_trips_filters: groupedTripsFiltersReducer,
  search: searchReducer,
  language: languageReducer,
  calendarDate: calendarDateReducer,
  begin_date_calendar: beginDateCalendarReducer,
  start_timeline: startTimelineReducer,
  end_timeline: endTimelineReducer,
  ...singletonReducers,
  ...crudListReducers,
  ...streamReducers,
  tripGroups: tripGroupsReducer,
  driverWarnings: driverWarningsReducer,
  distanceCache: distanceCacheReducer,
};

// Stato iniziale derivato dalla map: ogni reducer riceve `undefined` al
// primo invocation e restituisce il proprio initialState.
const initialState = Object.fromEntries(
  Object.keys(sliceReducers).map((k) => [k, sliceReducers[k](undefined, { type: '@@INIT' })])
);

export default function rootReducer(state = initialState, action) {
  // Logout: wipe the whole store back to the pristine initial state so no
  // data from the previous user leaks into the next session. Listeners are
  // already stopped by `resetStoreOnLogout` before this action is dispatched.
  if (action.type === AUTH_LOGOUT) {
    return initialState;
  }

  let next = state;
  for (const key in sliceReducers) {
    const nextSlice = sliceReducers[key](state[key], action);
    if (nextSlice !== state[key]) {
      next = next === state ? { ...state } : next;
      next[key] = nextSlice;
    }
  }
  return next;
}
